<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中……"
    element-loading-spinner="el-icon-loading"
  >
    <el-row type="flex" justify="space-around">
      <el-col :lg="14" :sm="24" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><b>基本信息</b> </span>
            <span v-if="isProfessionTech || isTechnique" style="float: right"
              >(*为必填项，投递时上传附件中包含的信息可以不填，有留学经历的在国(境)外留学情况选择:是)</span
            >
          </div>
          <el-form ref="postForm" :model="form" :rules="rules">
            <el-row v-if="!isMb">
              <el-col aria-rowspan="5" span="18">
                <el-form-item label="姓名:" prop="name" :required="isRequired">
                  <el-col :span="10">
                    <el-input
                      v-model="form.name"
                      placeholder="姓名"
                      maxlength="15"
                      style="width: 140px"
                      :readonly="isView"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="身份证号:"
                  prop="cardNumber"
                  :required="isRequired"
                >
                  <el-col :span="16"
                    ><el-input
                      v-model="form.cardNumber"
                      maxlength="20"
                      placeholder="身份证号"
                      style="width: 165px"
                      :readonly="isView"
                      @blur="readCardNumber"
                    ></el-input
                  ></el-col>
                </el-form-item>
                <el-form-item
                  label="注册手机号:"
                  prop="mobile"
                  :required="isRequired"
                >
                  <el-col :span="16"
                    ><el-input
                      v-model="form.mobile"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                      maxlength="11"
                      placeholder="输入注册时的手机号，否则账号的手机号将被修改"
                      readonly
                      disabled
                      style="width: 140px"
                      clearable
                    ></el-input
                  ></el-col>
                </el-form-item>
                <el-form-item label="性别:" prop="sex" :required="isRequired">
                  <el-col :span="16"
                    ><zr-combobox
                      v-model="form.sex"
                      :data-array="[
                        { name: '男', code: 'male' },
                        { name: '女', code: 'female' },
                      ]"
                      :readonly="isView"
                      value-field="code"
                      label-field="name"
                      style="width: 80px"
                    ></zr-combobox
                  ></el-col>
                </el-form-item>
                <el-form-item
                  label="出生年月日:"
                  prop="birthday"
                  :required="isRequired"
                >
                  <el-date-picker
                    v-model="form.birthday"
                    align="right"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :readonly="isView"
                    placeholder="选择出生年月日"
                    style="width: 140px"
                    @change="birthdayDateChange"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col span="6">
                <el-row>
                  <el-upload
                    title="照片上传"
                    class="avatar-uploader"
                    :headers="headers"
                    :action="pictureUploadAction"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-row>
                <el-row
                  ><span
                    v-if="!imageUrl"
                    class="el-upload__tip"
                    style="float: right; margin-right: 5px"
                    >png格式,1MB以内</span
                  ></el-row
                >
              </el-col>
            </el-row>
            <!--            手机端上面一坨 --------------->
            <el-row v-else>
              <el-col aria-rowspan="6" span="12">
                <el-row>*姓名: </el-row>
                <el-row>
                  <el-input
                    v-model="form.name"
                    placeholder="姓名"
                    maxlength="15"
                    style="width: 130px"
                    :readonly="isView"
                  ></el-input>
                </el-row>
                <el-row>*身份证号：</el-row>
                <el-row
                  ><el-input
                    v-model="form.cardNumber"
                    maxlength="20"
                    placeholder="身份证号"
                    style="width: 165px"
                    :readonly="isView"
                    @blur="readCardNumber"
                  ></el-input
                ></el-row>
                <el-row>*注册手机号：</el-row>
                <el-row>
                  <el-input
                    v-model="form.mobile"
                    onkeyup="value=value.replace(/[^\d]/g,'')"
                    maxlength="11"
                    placeholder="输入注册时的手机号，否则账号的手机号将被修改"
                    readonly
                    disabled
                    style="width: 140px"
                    clearable
                  ></el-input>
                </el-row>
                <el-row>*性别: </el-row>
                <el-row>
                  <zr-combobox
                    v-model="form.sex"
                    :data-array="[
                      { name: '男', code: 'male' },
                      { name: '女', code: 'female' },
                    ]"
                    :readonly="isView"
                    value-field="code"
                    label-field="name"
                    style="width: 120px"
                  ></zr-combobox>
                </el-row>
              </el-col>
              <el-col span="12">
                <el-row>
                  <el-upload
                    title="照片上传"
                    class="avatar-uploader"
                    :headers="headers"
                    :action="pictureUploadAction"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-row>
                <el-row>
                  <span
                    v-if="!imageUrl"
                    class="el-upload__tip"
                    style="float: right; margin-right: 5px"
                    >png格式,1MB以内</span
                  >
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="isMb">
              <el-form-item label="出生年月日:" prop="birthday">
                <el-col :span="16"
                  ><el-date-picker
                    v-model="form.birthday"
                    align="right"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :readonly="isView"
                    placeholder="选择出生年月日"
                    style="width: 140px"
                    @change="birthdayDateChange"
                  ></el-date-picker
                ></el-col>
              </el-form-item>
            </el-row>
            <el-form-item label="邮箱:" prop="email" required>
              <el-col :span="16"
                ><el-input
                  v-model="form.email"
                  maxlength="30"
                  placeholder="邮箱"
                  clearable
                ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item label="政治面貌:" prop="politicallyState" required>
              <zr-combobox
                v-model="form.politicallyState"
                :data-array="basicPoliticallyState"
                value-field="code"
                label-field="name"
                :readonly="isView"
                style="width: 135px"
              ></zr-combobox>
            </el-form-item>
            <!--            <el-form-item label="籍贯/出生地:" prop="birthdayLocal"  :required="isRequired">-->
            <!--              <el-col :span="16">-->
            <!--                <el-input-->
            <!--                  v-model="form.birthdayLocal"-->
            <!--                  placeholder="籍贯/出生地"-->
            <!--                  maxlength="15"-->
            <!--                  clearable-->
            <!--                ></el-input>-->
            <!--              </el-col>-->
            <!--            </el-form-item>-->
            <el-form-item
              label="籍贯:"
              prop="birthdayLocal"
              :required="isRequired"
            >
              <zr-combobox
                v-model="form.birthdayLocal"
                :data-array="basicBirthdayLocal"
                value-field="code"
                label-field="name"
                :readonly="isView"
                style="width: 135px"
                filterable
              ></zr-combobox>
            </el-form-item>
            <el-form-item
              label="出生地:"
              prop="placeOfOrigin"
              :required="isRequired"
            >
              <el-col :span="16">
                <!--                <el-input-->
                <!--                  v-model="form.placeOfOrigin"-->
                <!--                  placeholder="生源地"-->
                <!--                  maxlength="15"-->
                <!--                  clearable-->
                <!--                ></el-input>-->
                <zr-combobox
                  v-model="form.placeOfOrigin"
                  :data-array="basicBirthdayLocal"
                  value-field="code"
                  label-field="name"
                  :readonly="isView"
                  style="width: 135px"
                  filterable
                ></zr-combobox>
              </el-col>
            </el-form-item>
            <el-form-item
              label="高考时户籍所在地:"
              prop="nativePlace"
              :required="isRequired"
            >
              <zr-combobox
                v-model="form.nativePlace"
                :data-array="basicBirthdayLocal"
                value-field="code"
                label-field="name"
                :readonly="isView"
                style="width: 135px"
                filterable
              ></zr-combobox>
            </el-form-item>
            <el-form-item
              label="国籍:"
              prop="nationality"
              :required="isRequired"
            >
              <!--              <zr-combobox-->
              <!--                v-model="form.nationality"-->
              <!--                :data-array="[-->
              <!--                  { name: '中华人民共和国', code: 'china' },-->
              <!--                  { name: '其他', code: 'other' },-->
              <!--                ]"-->
              <!--                value-field="code"-->
              <!--                label-field="name"-->
              <!--                :readonly="isView"-->
              <!--                style="width: 150px"-->
              <!--              ></zr-combobox>-->
              <zr-combobox
                v-model="form.nationality"
                :data-array="basicNationality"
                value-field="code"
                label-field="name"
                :readonly="isView"
                style="width: 150px"
                filterable
              ></zr-combobox>
            </el-form-item>
            <el-form-item label="民族:" prop="nation" :required="isRequired">
              <el-col :span="16"
                ><zr-combobox
                  v-model="form.nation"
                  :data-array="nationArray"
                  value-field="code"
                  label-field="name"
                  style="width: 135px"
                  filterable
                ></zr-combobox
              ></el-col>
            </el-form-item>
            <el-form-item label="婚否:" prop="married">
              <zr-combobox
                v-model="form.married"
                :data-array="[
                  { name: '已婚', code: 1 },
                  { name: '未婚', code: 0 },
                ]"
                value-field="code"
                label-field="name"
                style="width: 135px"
                @change="onMarriedChange"
              ></zr-combobox>
            </el-form-item>
            <el-form-item
                label="国(境)外留学情况:"
                prop="hasBroadExp"
                :required="isRequired"
            >
              <zr-combobox
                v-model="form.hasBroadExp"
                placeholder="有海外关系或工作学习经历"
                clearable
                :data-array="[
                  { name: '是', code: 1 },
                  { name: '否', code: 0 },
                ]"
                value-field="code"
                label-field="name"
                style="width: 240px"
              ></zr-combobox>
              <!--              （有海外留学经历的必填）-->
            </el-form-item>

            <!--            <el-form-item label="国籍:" prop="nationality">-->
            <!--              <el-col :span="16"-->
            <!--                ><el-input-->
            <!--                  v-model="form.nationality"-->
            <!--                  maxlength="20"-->
            <!--                  placeholder="国籍"-->
            <!--                  clearable-->
            <!--                ></el-input-->
            <!--              ></el-col>-->
            <!--            </el-form-item>-->
            <el-form-item
              label="配偶国籍:"
              prop="spouseNationality"
              :required="isMarriedRequired"
            >
              <el-col :span="16">
                <zr-combobox
                  v-model="form.spouseNationality"
                  :data-array="basicNationality"
                  value-field="code"
                  label-field="name"
                  :readonly="isView"
                  style="width: 150px"
                  filterable
                ></zr-combobox>
              </el-col>
            </el-form-item>
            <!--            <el-form-item label="家庭主要成员信息:" prop="familyMember">-->
            <!--              <el-col :span="16">-->
            <!--                <el-input-->
            <!--                  v-model="form.familyMember"-->
            <!--                  clearable-->
            <!--                  type="textarea"-->
            <!--                  maxlength="800"-->
            <!--                  show-word-limit-->
            <!--                  :rows="5"-->
            <!--                  :autosize="{ minRows: 5, maxRows: 20 }"-->
            <!--                  placeholder="有国(境)外留学情况的必须注明!"-->
            <!--                ></el-input>-->
            <!--              </el-col>-->
            <!--            </el-form-item>-->
            <el-form-item label="身高:" prop="high">
              <el-input-number
                v-model="form.high"
                placeholder="身高"
                size="mini"
                :min="0"
                :precision="0"
                :step="1"
                clearable
              ></el-input-number
              >&nbsp;cm
            </el-form-item>
            <el-form-item label="体重:" prop="weight">
              <el-input-number
                v-model="form.weight"
                placeholder="体重"
                size="mini"
                :min="0"
                :precision="0"
                :step="1"
                clearable
              ></el-input-number
              >&nbsp;kg
            </el-form-item>
            <el-form-item label="特长:" prop="speciality">
              <el-col :span="16"
                ><el-input
                  v-model="form.speciality"
                  maxlength="30"
                  placeholder="特长"
                  clearable
                ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item label="爱好:" prop="hobby">
              <el-col :span="16"
                ><el-input
                  v-model="form.hobby"
                  maxlength="30"
                  placeholder="爱好"
                  clearable
                ></el-input
              ></el-col>
            </el-form-item>
            <el-form-item
              v-if="isProfessionTech || isTechnique ? false : true"
              label="自我评价及其他说明:"
              prop="remark"
            >
              <el-col :span="20">
                <el-input
                  v-model="form.remark"
                  clearable
                  type="textarea"
                  maxlength="1000"
                  show-word-limit
                  :rows="4"
                  :autosize="{ minRows: 4, maxRows: 20 }"
                  placeholder="自我评价及其他说明。如选择我所原因，实践活动要求。"
                ></el-input>
              </el-col>
            </el-form-item>
            <el-divider />
            <div style="margin-bottom: 10px">
              <el-row>
                <el-col :span="20"
                  ><span class="spanTitle">家庭成员</span>
                </el-col>
              </el-row>
            </div>
            <el-card>
              <div style="overflow: auto; height: 360px">
                <el-button
                  icon="el-icon-plus"
                  type="primary"
                  @click="addFamilyMember"
                  >新增</el-button
                >
                <zr-table
                  ref="familyTable"
                  height-fixed
                  class="user-box"
                  :loading-show="familyLoading"
                  selection-type="single"
                  :data="form.familyInfo"
                  :columns="familyColumns"
                  table-height="300px"
                  style="overflow: auto"
                  stripe
                  @row-click="familyClick"
                >
                  <template v-slot:relationship="{ row }">
                    <el-select v-model="row['relationship']">
                      <el-option
                        v-for="item in basicFamily"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-slot:name="{ row }">
                    <el-input
                      v-model="row['name']"
                      size="mini"
                      maxlength="10"
                    ></el-input>
                  </template>
                  <template v-slot:sex="{ row }">
                    <el-select v-model="row['sex']">
                      <el-option
                        v-for="item in basicSex"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-slot:birthDay="{ row }">
                    <el-date-picker
                      v-model="row['birthDay']"
                      type="date"
                      placeholder="选择出生日期"
                    >
                    </el-date-picker>
                  </template>
                  <template v-slot:nation="{ row }">
                    <el-select v-model="row['nation']" clearable filterable>
                      <el-option
                        v-for="item in nationArray"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-slot:politicallyState="{ row }">
                    <el-select v-model="row['politicallyState']" clearable filterable>
                      <el-option
                        v-for="item in basicPoliticallyState"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </template>
                  <template v-slot:deptAndHeadship="{ row }">
                    <el-input
                      v-model="row['deptAndHeadship']"
                      size="mini"
                      maxlength="500"
                      clearable
                    ></el-input>
                  </template>
                  <template v-slot:operate="{ row }">
                    <el-button type="text" @click="delFamily(row)"
                      >删除</el-button
                    >
                  </template>
                </zr-table>
              </div>
            </el-card>
            <div v-if="isProfessionTech || isTechnique ? true : false">
              <el-row>
                <el-col :span="20"
                  ><span class="spanTitle"
                    >高等教育学习经历(学习阶段请按照从低到高依次往下填写)
                    {{
                      isTechnique && !isView ? "（限大专或高职毕业生）" : ""
                    }}</span
                  >
                </el-col>
                <el-col :span="4"
                  ><el-tag style="float: right">{{
                    isProfessionTech ? "专技类" : "技能类"
                  }}</el-tag></el-col
                >
              </el-row>
              <el-row v-if="false">
                <span>
                  <br />{{
                    isProfessionTech
                      ? "(硕士/非学术型，务必备注：大四时是否具有推免资格，硕士所修学分是否不低于学术型的标准)"
                      : ""
                  }}</span
                >
              </el-row>
              <el-divider />
              <!--专技类-->
              <div v-if="isProfessionTech">
                <el-row>
                  <el-col span="18">
                    <el-form-item label="最高学历:" prop="topDegree">
                      <zr-combobox
                        v-model="form.topDegree"
                        placeholder="选择最高教育经历"
                        :data-array="[
                          { name: '其它', code: '其它' },
                          { name: '大学专科毕业', code: '大学专科毕业' },
                          { name: '大学本科毕业', code: '大学本科毕业' },
                          { name: '硕士研究生毕业', code: '硕士研究生毕业' },
                          { name: '博士研究生毕业', code: '博士研究生毕业' },
                        ]"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        @change="topDegreeChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                  <el-col span="6">
                    <el-button
                      style="float: left; padding: 3px 0"
                      icon="el-icon-circle-plus-outline"
                      type="primary"
                      @click="addPhase"
                      >添加阶段</el-button
                    >
                    &nbsp; * <span style="color: gray">(学习阶段必填)</span>
                  </el-col>
                </el-row>
                <el-card
                  v-for="row in form.experienceList"
                  :key="row.phase"
                  style=""
                >
                  <div slot="header">
                    <zr-combobox
                      v-model="row.phase"
                      placeholder="阶段"
                      :data-array="[
                        { name: '其它', code: '其它' },
                        { name: '大学专科毕业', code: '大学专科毕业' },
                        { name: '大学本科毕业', code: '大学本科毕业' },
                        { name: '硕士研究生毕业', code: '硕士研究生毕业' },
                        { name: '博士研究生毕业', code: '博士研究生毕业' },
                      ]"
                      value-field="code"
                      label-field="name"
                      @change="phaseChange(row)"
                    ></zr-combobox>
                    <el-button
                      style="float: right; padding: 3px 0"
                      icon="el-icon-minus"
                      type="text"
                      @click="deletePhase(row)"
                      >删除</el-button
                    >
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:">
                        <el-date-picker
                          v-model="row.startDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:">
                        <el-date-picker
                          v-model="row.endDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业单位:" prop="university">
                        <el-col :span="16"
                          ><el-select
                            v-model="row.university"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in schoolArray"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学院/系:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.institutions"
                            placeholder="请输入学院/系"
                            maxlength="15"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="一级学科:">
                        <el-col :span="16">
                          <select-tree
                            v-model="row.studyField"
                            :row="row"
                            :tree-data="loadTreeData(row)"
                          ></select-tree>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="毕业专业:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.majorCourse"
                            placeholder="请输入获学位专业"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="专业总人数:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.totalNumber"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            placeholder="只能为数字"
                            maxlength="5"
                            @blur="(e) => salaryNewChange(e, row)"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="综合排名:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.rankNum"
                            onkeyup="value=value.replace(/[^\d]/g,'')"
                            placeholder="综合排名只能为数字"
                            maxlength="5"
                            @blur="(e) => salaryChange(e, row)"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningShape">
                        <el-col :span="16"
                          ><el-select
                            v-model="row.learningShape"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in basicLearningFormat"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <!--                    <el-col :lg="12" :sm="24" :xs="24">-->
                    <!--                      <el-form-item label="学位:" prop="degreeNameExp">-->
                    <!--                        <el-col :span="16"-->
                    <!--                          ><el-select-->
                    <!--                            v-model="row.degreeNameExp"-->
                    <!--                            allow-create-->
                    <!--                            clearable-->
                    <!--                            filterable-->
                    <!--                          >-->
                    <!--                            <el-option-->
                    <!--                              v-for="item in basicDegree"-->
                    <!--                              :key="item.code"-->
                    <!--                              :label="item.name"-->
                    <!--                              :value="item.code"-->
                    <!--                            />-->
                    <!--                          </el-select>-->
                    <!--                        </el-col>-->
                    <!--                      </el-form-item>-->
                    <!--                    </el-col>-->
                  </el-row>
                  <el-row>
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item label="备注:">
                        <el-col :span="17">
                          <el-input
                            v-model="row.remark"
                            placeholder="请输入备注"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-row>
                  <el-col span="18">
                    <el-form-item label="最高学位:" prop="topDegree">
                      <zr-combobox
                        v-model="form.topDegreeName"
                        placeholder="选择最高学位"
                        :data-array="basicDegree"
                        value-field="code"
                        label-field="name"
                        style="width: 135px"
                        @change="topDegreeNameChange"
                      ></zr-combobox>
                    </el-form-item>
                  </el-col>
                  <el-col span="6">
                    <el-button
                      style="float: left; padding: 3px 0"
                      icon="el-icon-circle-plus-outline"
                      type="primary"
                      @click="addDegree"
                      >添加学位情况</el-button
                    >
                    &nbsp; * <span style="color: gray">(学位情况必填)</span>
                  </el-col>
                </el-row>
                <el-card
                  v-for="row in form.degreeList"
                  :key="row.degreeName"
                  style=""
                >
                  <div slot="header">
                    <zr-combobox
                      v-model="row.degreeName"
                      placeholder="学位"
                      :data-array="basicDegree"
                      value-field="code"
                      label-field="name"
                    ></zr-combobox>
                    <el-button
                      style="float: right; padding: 3px 0"
                      icon="el-icon-minus"
                      type="text"
                      @click="deleteDegree(row)"
                      >删除</el-button
                    >
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:">
                        <el-date-picker
                          v-model="row.startDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:">
                        <el-date-picker
                          v-model="row.endDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学位授予单位:" prop="degreeDept">
                        <el-col :span="16"
                          ><el-select
                            v-model="row.degreeDept"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in schoolArray"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningFormat">
                        <el-col :span="16"
                          ><el-select
                            v-model="row.learningFormat"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in basicLearningFormat"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位学科:">
                        <el-col :span="16">
                          <select-tree
                            v-model="row.degreeScience"
                            :row="row"
                            :tree-data="loadTreeData(row)"
                          ></select-tree>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="获学位专业:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.degreeStudyField"
                            placeholder="请输入获学位专业"
                            maxlength="30"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">语言情况</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 360px">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      @click="addLanguageInfo"
                      >新增</el-button
                    >
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.languageInfoList"
                      :columns="languageInfoColumns"
                      table-height="300px"
                      stripe
                    >
                      <template v-slot:languageClass="{ row }">
                        <el-select v-model="row['languageClass']">
                          <el-option
                            v-for="item in basicLanguage"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </template>
                      <template v-slot:languageCertificate="{ row }">
                        <el-select v-model="row['languageCertificate']" allow-create clearable filterable>
                          <el-option
                            v-for="item in basicEnglishLevel"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                          >
                          </el-option>
                        </el-select>
                      </template>
                      <template v-slot:languageScore="{ row }">
                        <el-input
                          v-model="row['languageScore']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:achievement="{ row }">
                        <el-input
                          v-model="row['achievement']"
                          size="mini"
                          maxlength="500"
                          clearable
                        ></el-input>
                      </template>
                      <template v-slot:operate="{ row }">
                        <el-button type="text" @click="delLanguageInfo(row)"
                          >删除</el-button
                        >
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">实习经历</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 360px">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      @click="addPracticeLive"
                      >新增</el-button
                    >
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.parcticeLiveList"
                      :columns="parcticeLiveColumns"
                      table-height="300px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
                        <el-input
                          v-model="row['companyName']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:location="{ row }">
                        <el-input
                          v-model="row['location']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:workDeptName="{ row }">
                        <el-input
                          v-model="row['workDeptName']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:workPostName="{ row }">
                        <el-input
                          v-model="row['workPostName']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:achievement="{ row }">
                        <el-input
                          v-model="row['achievement']"
                          size="mini"
                          maxlength="500"
                          clearable
                        ></el-input>
                      </template>
                      <template v-slot:operate="{ row }">
                        <el-button type="text" @click="delPracticeLive(row)"
                          >删除</el-button
                        >
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">工作经历</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 360px">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      @click="addWorkLive"
                      >新增</el-button
                    >
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.workLiveList"
                      :columns="workLiveColumns"
                      table-height="300px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:companyName="{ row }">
                        <el-input
                          v-model="row['companyName']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:location="{ row }">
                        <el-input
                          v-model="row['location']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:workDeptName="{ row }">
                        <el-input
                          v-model="row['workDeptName']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:workPostName="{ row }">
                        <el-input
                          v-model="row['workPostName']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:achievement="{ row }">
                        <el-input
                          v-model="row['achievement']"
                          size="mini"
                          maxlength="500"
                          clearable
                        ></el-input>
                      </template>
                      <template v-slot:operate="{ row }">
                        <el-button type="text" @click="delWorkLive(row)"
                          >删除</el-button
                        >
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <div style="margin-bottom: 10px">
                  <el-row>
                    <el-col :span="20"
                      ><span class="spanTitle">科研项目经历</span>
                    </el-col>
                  </el-row>
                </div>
                <el-card>
                  <div style="overflow: auto; height: 360px">
                    <el-button
                      icon="el-icon-plus"
                      type="primary"
                      @click="addProjectLive"
                      >新增</el-button
                    >
                    <zr-table
                      ref="familyTable"
                      height-fixed
                      class="user-box"
                      selection-type="single"
                      :data="form.projectLiveList"
                      :columns="projectLiveColumns"
                      table-height="300px"
                      stripe
                    >
                      <template v-slot:startLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['startLiveTime']"
                          type="date"
                          placeholder="选择开始日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:endLiveTime="{ row }">
                        <el-date-picker
                          v-model="row['endLiveTime']"
                          type="date"
                          placeholder="选择结束日期"
                        >
                        </el-date-picker>
                      </template>
                      <template v-slot:projectName="{ row }">
                        <el-input
                          v-model="row['projectName']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:projectRole="{ row }">
                        <el-input
                          v-model="row['projectRole']"
                          size="mini"
                          maxlength="32"
                        ></el-input>
                      </template>
                      <template v-slot:companyName="{ row }">
                        <el-input
                          v-model="row['companyName']"
                          size="mini"
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:achievement="{ row }">
                        <el-input
                          v-model="row['achievement']"
                          size="mini"
                          clearable
                          maxlength="500"
                        ></el-input>
                      </template>
                      <template v-slot:operate="{ row }">
                        <el-button type="text" @click="delProjectLive(row)"
                          >删除</el-button
                        >
                      </template>
                    </zr-table>
                  </div>
                </el-card>
                <el-form-item
                  label="是否应届生:"
                  prop="education.freshGraduate"
                  :required="isRequired"
                >
                  <zr-combobox
                    v-model="form.education.freshGraduate"
                    placeholder="是否应届生"
                    :data-array="[
                      { name: '是', code: '是' },
                      { name: '否', code: '否' },
                    ]"
                    value-field="code"
                    label-field="name"
                    style="width: 135px"
                    clearable
                  ></zr-combobox>
                </el-form-item>
                <!--                <el-form-item-->
                <!--                  label="最高学位:"-->
                <!--                  prop="education.degreeName"-->
                <!--                  :required="isRequired"-->
                <!--                >-->
                <!--                  <zr-combobox-->
                <!--                    v-model="form.education.degreeName"-->
                <!--                    placeholder="学位"-->
                <!--                    :data-array="basicDegree"-->
                <!--                    value-field="code"-->
                <!--                    label-field="name"-->
                <!--                    style="width: 135px"-->
                <!--                    clearable-->
                <!--                  ></zr-combobox>-->
                <!--                </el-form-item>-->
                <!--                <el-form-item-->
                <!--                  label="英语水平:"-->
                <!--                  prop="education.engLevel"-->
                <!--                  :required="isRequired"-->
                <!--                >-->
                <!--                  <zr-combobox-->
                <!--                    v-model="form.education.engLevel"-->
                <!--                    placeholder="CET/TEM"-->
                <!--                    :data-array="[-->
                <!--                      { name: '英语四级', code: 'CET4' },-->
                <!--                      { name: '英语六级', code: 'CET6' },-->
                <!--                      { name: '其他', code: 'TEM4' },-->
                <!--                    ]"-->
                <!--                    value-field="code"-->
                <!--                    label-field="name"-->
                <!--                    style="width: 135px"-->
                <!--                    clearable-->
                <!--                  ></zr-combobox>-->
                <!--                </el-form-item>-->
<!--                <el-row>-->
<!--                  <el-col :lg="12" :sm="24" :xs="24">-->
<!--                    <el-form-item-->
<!--                      label="英语水平:"-->
<!--                      prop="education.engLevel"-->
<!--                      :required="isRequired"-->
<!--                    >-->
<!--                      <zr-combobox-->
<!--                        v-model="form.education.engLevel"-->
<!--                        placeholder="CET/TEM"-->
<!--                        :data-array="[-->
<!--                          { name: '英语四级', code: 'CET4' },-->
<!--                          { name: '英语六级', code: 'CET6' },-->
<!--                          { name: '专业英语四级', code: 'TEM4' },-->
<!--                          { name: '专业英语八级', code: 'TEM8' },-->
<!--                          { name: 'GRE', code: 'GRE' },-->
<!--                          { name: 'GMAT', code: 'GMAT' },-->
<!--                          { name: 'TOEFL', code: 'TOEFL' },-->
<!--                          { name: 'IELTS', code: 'IELTS' },-->
<!--                          { name: '其他', code: 'OTHER' },-->
<!--                        ]"-->
<!--                        value-field="code"-->
<!--                        label-field="name"-->
<!--                        style="width: 135px"-->
<!--                        clearable-->
<!--                      ></zr-combobox>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                  <el-col :lg="12" :sm="24" :xs="24">-->
<!--                    <el-form-item-->
<!--                      label="具体分数:"-->
<!--                      prop="education.engLevelScore"-->
<!--                      :required="isRequired"-->
<!--                      ><el-input-->
<!--                        v-model="form.education.engLevelScore"-->
<!--                        placeholder="具体分数"-->
<!--                        style="width: 135px"-->
<!--                        clearable-->
<!--                      ></el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-col>-->
<!--                </el-row>-->
                <el-form-item
                  label="主干课程:"
                  prop="education.course"
                  :required="isRequired"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.course"
                      clearable
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      :rows="2"
                      :autosize="{ minRows: 2, maxRows: 20 }"
                      placeholder="主干课程"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <!--                <el-form-item-->
                <!--                  label="预计毕业日期:"-->
                <!--                  prop="education.graduateDate"-->
                <!--                >-->
                <!--                  <el-date-picker-->
                <!--                    v-model="form.education.graduateDate"-->
                <!--                    align="right"-->
                <!--                    type="date"-->
                <!--                    format="yyyy-MM-dd"-->
                <!--                    value-format="yyyy-MM-dd"-->
                <!--                    placeholder="选择预计毕业日期"-->
                <!--                    style="width: 135px"-->
                <!--                    @change="graduateDateChange"-->
                <!--                  ></el-date-picker>-->
                <!--                </el-form-item>-->
                <el-form-item label="计算机等级:" prop="education.programLevel">
                  <el-col :span="16"
                    ><el-input
                      v-model="form.education.programLevel"
                      maxlength="20"
                      placeholder="计算机/程序员等级（注明全国/地区）"
                      clearable
                    ></el-input
                  ></el-col>
                </el-form-item>
                <el-form-item
                  label="科研方向:"
                  prop="education.researchOrientation"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.researchOrientation"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="各阶段科研方向"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="实习经历:" prop="education.internship">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.internship"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="兼职、实习经历"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="工作经历:" prop="education.workexp">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.workexp"
                      clearable
                      type="textarea"
                      maxlength="500"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="含博士后，不含兼职实习"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="科研项目经历:"
                  prop="education.scientificOrientation"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.scientificOrientation"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="承担角色及主要工作介绍"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="代表性学术成果(文章专利):"
                  prop="education.achievement"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.achievement"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="刊物名称、作者排名、影响因子、文章分区"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="高校获奖情况:" prop="education.prizeCase">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.prizeCase"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="校级综合奖学金、国际/国家/省部/赛区级的科技比赛获奖、科技进步奖、技术发明奖、自然科学奖等（务必注明有无证书原件）"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="技能大赛获奖类别:"
                  prop="education.winAwardType"
                >
                  <zr-combobox
                    v-model="form.education.winAwardType"
                    :data-array="[
                      { name: '国赛', code: '国赛' },
                      { name: '省赛', code: '省赛' },
                      { name: '其他', code: '其他' },
                    ]"
                    value-field="code"
                    label-field="name"
                    style="width: 135px"
                    clearable
                  ></zr-combobox>
                </el-form-item>
                <el-form-item label="获奖等级:" prop="education.winAwardLevel">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.winAwardLevel"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="获奖名称:" prop="education.winAwardName">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.winAwardName"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="学生工作社团组织:"
                  prop="education.massCase"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.massCase"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="学生工作社团组织"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="自我评价及其他说明:" prop="remark">
                  <el-col :span="20">
                    <el-input
                      v-model="form.remark"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="自我评价及其他说明。如选择我所原因，实践活动要求。"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </div>
              <!--技能类-->
              <div v-if="isTechnique">
                <el-row>
                  <el-button
                    style="float: left; padding: 3px 0"
                    icon="el-icon-circle-plus-outline"
                    type="primary"
                    @click="addPhase"
                    >添加阶段</el-button
                  >
                  &nbsp; * <span style="color: gray">(学习阶段必填)</span>
                </el-row>
                <el-card
                  v-for="row in form.experienceList"
                  :key="row.phase"
                  style=""
                >
                  <div slot="header">
                    <zr-combobox
                      v-model="row.phase"
                      placeholder="阶段"
                      :data-array="[
                        // { name: '大专', code: '大专' },
                        // { name: '本科', code: '本科' },
                        { name: '大学专科毕业', code: '大学专科毕业' },
                        { name: '大学本科毕业', code: '大学本科毕业' },
                      ]"
                      value-field="code"
                      label-field="name"
                      @change="phaseChange(row)"
                    ></zr-combobox>
                    <el-button
                      style="float: right; padding: 3px 0"
                      icon="el-icon-minus"
                      type="text"
                      @click="deletePhase(row)"
                      >删除</el-button
                    >
                  </div>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="开始日期:">
                        <el-date-picker
                          v-model="row.startDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择开始日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="结束日期:">
                        <el-date-picker
                          v-model="row.endDate"
                          align="right"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          placeholder="选择结束日期"
                          style="width: 135px"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item
                        label="学校(选择框中不存在的请手填准确名称):"
                        prop="university"
                      >
                        <el-col :span="16"
                          ><el-select
                            v-model="row.university"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in schoolArray"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学院/系:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.institutions"
                            placeholder="请输入学院/系"
                            maxlength="15"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="专业:">
                        <el-col :span="16">
                          <!--                          <el-input-->
                          <!--                            v-model="row.studyField"-->
                          <!--                            placeholder="请输入专业"-->
                          <!--                            maxlength="15"-->
                          <!--                          />-->
                          <select-tree
                            v-model="row.studyField"
                            :row="row"
                            :tree-data="loadTreeData(row)"
                          ></select-tree>
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <!--                  <el-row>-->
                  <!--                    <el-col :lg="24" :sm="24" :xs="24">-->
                  <!--                      <el-form-item label="学科评估:">-->
                  <!--                        <el-col :span="16">-->
                  <!--                          <el-input-->
                  <!--                            v-model="row.disciplineEvaluation"-->
                  <!--                            placeholder="请输入学科评估"-->
                  <!--                            maxlength="30"-->
                  <!--                          />-->
                  <!--                        </el-col>-->
                  <!--                      </el-form-item>-->
                  <!--                    </el-col>-->
                  <!--                  </el-row>-->
                  <el-row>
                    <el-col :lg="12" :sm="24" :xs="24">
                      <el-form-item label="学习形式:" prop="learningShape">
                        <el-col :span="16"
                          ><el-select
                            v-model="row.learningShape"
                            allow-create
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in basicLearningFormat"
                              :key="item.code"
                              :label="item.name"
                              :value="item.code"
                            />
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <!--                    <el-col :lg="12" :sm="24" :xs="24">-->
                    <!--                      <el-form-item label="学位:" prop="degreeNameExp">-->
                    <!--                        <el-col :span="16"-->
                    <!--                          ><el-select-->
                    <!--                            v-model="row.degreeNameExp"-->
                    <!--                            allow-create-->
                    <!--                            clearable-->
                    <!--                            filterable-->
                    <!--                          >-->
                    <!--                            <el-option-->
                    <!--                              v-for="item in basicDegree"-->
                    <!--                              :key="item.code"-->
                    <!--                              :label="item.name"-->
                    <!--                              :value="item.code"-->
                    <!--                            />-->
                    <!--                          </el-select>-->
                    <!--                        </el-col>-->
                    <!--                      </el-form-item>-->
                    <!--                    </el-col>-->
                  </el-row>
                  <el-row>
                    <el-col :lg="24" :sm="24" :xs="24">
                      <el-form-item label="备注:">
                        <el-col :span="16">
                          <el-input
                            v-model="row.remark"
                            placeholder="请输入备注"
                            maxlength="15"
                          />
                        </el-col>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-card>
                <el-form-item
                  label="大专毕业日期:"
                  prop="education.graduateDate"
                >
                  <el-date-picker
                    v-model="form.education.graduateDate"
                    align="right"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择大专学历毕业日期"
                    @change="graduateDateChange"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item
                  label="高校英语考试:"
                  prop="education.isPassEngUseExam"
                >
                  <zr-combobox
                    v-model="form.education.isPassEngUseExam"
                    placeholder="高等学校英语应用能力考试"
                    :data-array="[
                      { name: '通过', code: 1 },
                      { name: '不通过', code: 0 },
                    ]"
                    value-field="code"
                    label-field="name"
                    clearable
                  ></zr-combobox>
                </el-form-item>
                <el-form-item
                  v-if="isTechnique"
                  label="国家职业资格:"
                  prop="education.professionLevel"
                >
                  <el-col :span="16"
                    ><el-input
                      v-model="form.education.professionLevel"
                      maxlength="20"
                      placeholder="国家职业资格等级"
                      clearable
                    ></el-input
                  ></el-col>
                </el-form-item>
                <el-form-item label="计算机等级:" prop="education.programLevel">
                  <el-col :span="16"
                    ><el-input
                      v-model="form.education.programLevel"
                      maxlength="20"
                      placeholder="计算机/程序员等级（注明全国/地区）"
                      clearable
                    ></el-input
                  ></el-col>
                </el-form-item>
                <el-form-item
                  label="主干课程:"
                  prop="education.course"
                  :required="isRequired"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.course"
                      clearable
                      type="textarea"
                      maxlength="300"
                      show-word-limit
                      :rows="2"
                      :autosize="{ minRows: 2, maxRows: 20 }"
                      placeholder="主干课程"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="实习经历:" prop="education.internship">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.internship"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="兼职、实习经历"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="高校获奖情况:" prop="education.prizeCase">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.prizeCase"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="校级综合奖学金、国际/国家/省部/赛区级的科技比赛获奖、科技进步奖、技术发明奖、自然科学奖等（务必注明有无证书原件）"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="学生工作社团组织:"
                  prop="education.massCase"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.massCase"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="学生工作社团组织"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="技能大赛获奖类别:"
                  prop="education.winAwardType"
                >
                  <zr-combobox
                    v-model="form.education.winAwardType"
                    :data-array="[
                      { name: '国赛', code: '国赛' },
                      { name: '省赛', code: '省赛' },
                      { name: '其他', code: '其他' },
                    ]"
                    value-field="code"
                    label-field="name"
                    style="width: 135px"
                    clearable
                  ></zr-combobox>
                </el-form-item>
                <el-form-item label="获奖等级:" prop="education.winAwardLevel">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.winAwardLevel"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="获奖名称:" prop="education.winAwardName">
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.winAwardName"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="技能比赛获奖情况:"
                  prop="education.skillGameInfo"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.skillGameInfo"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="技能比赛获奖情况"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item
                  label="技能比赛实操情况说明:"
                  prop="education.actualOperateInfo"
                >
                  <el-col :span="20">
                    <el-input
                      v-model="form.education.actualOperateInfo"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="技能比赛实操情况说明"
                    ></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="自我评价及其他说明:" prop="remark">
                  <el-col :span="20">
                    <el-input
                      v-model="form.remark"
                      clearable
                      type="textarea"
                      maxlength="1000"
                      show-word-limit
                      :rows="4"
                      :autosize="{ minRows: 4, maxRows: 20 }"
                      placeholder="自我评价及其他说明。如选择我所原因，实践活动要求。"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </div>
              <el-upload
                v-if="isPost || isView"
                ref="upload"
                title="附件上传"
                :headers="headers"
                :action="uploadAction"
                :on-preview="handleDownload"
                :before-upload="beforeUpload"
                :on-exceed="handleExceed"
                :before-remove="beforeRemove"
                :on-remove="handleRemove"
                :on-success="uploadSucceed"
                :file-list="form.fileList"
              >
                <el-button v-if="!isView" size="small" type="primary"
                  >附件上传</el-button
                ><span v-if="!isView" style="color: gray">
<!--                  可以是完整的简历，本页面只填写基本信息，也可以是证书照片等文件，或者zip包，大小不超过50MB-->
                 系统会根据您填写的内容自动生成简历信息，附件仅需上传证书，照片，奖状等内容，或者zip包，大小不超过50MB
                </span>
              </el-upload>
              <el-divider />
            </div>
          </el-form>
          <slot name="footBtn" :form="form">
            <el-button
              v-if="!isView && loginUser && !isPost"
              icon="el-icon-circle-check"
              type="success"
              style="float: right"
              @click="doSave"
              >保存</el-button
            >
            <el-button
              v-if="
                !isView &&
                loginUser &&
                (isProfessionTech || isTechnique) &&
                isPost
              "
              icon="el-icon-circle-check"
              type="success"
              style="float: right"
              @click="doSave"
              >投递简历</el-button
            >
            <el-button
              v-if="isView && loginUser && !collected"
              icon="el-icon-circle-check"
              type="primary"
              style="float: right"
              @click="doCollect"
              >收藏</el-button
            >
            <el-button
              v-if="isView && loginUser && collected"
              icon="el-icon-circle-close"
              type="primary"
              style="float: right"
              @click="doDisCollect"
              >取消收藏</el-button
            >
            <el-button
              v-if="isView && loginUser && !unSuit"
              icon="el-icon-circle-close"
              type="info"
              style="float: right"
              @click="doUnSuit"
              >不合适</el-button
            >
            <el-button
              v-if="isView && loginUser && unSuit"
              icon="el-icon-circle-check"
              type="info"
              style="float: right"
              @click="doSuit"
              >合适</el-button
            >
            <el-button
              icon="el-icon-back"
              style="float: right"
              type="success"
              plain
              @click="back"
              >返回</el-button
            >
          </slot>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getLocation } from "./locationData";
import { getBasicData } from "@/api/job/postInfo";
import { getUniversity } from "@/api/recruit/applicant/positionList";
import {
  getAllResumeInfoByPositionIdAndUserPhone,
  getResumeInfoById,
  getResumeInfoByUserPhone,
  saveResumeInfo,
  unSuitResume,
  suitResume,
  collectResume,
  unCollectResume,
} from "@/api/recruit/user/resume";
import { deleteFileById } from "@/api/recruit/user/upload";
import { downloadFile } from "@/utils/downFile";
import isMobile from "@/utils/device";
import { mapGetters } from "vuex";
import settingHelp from "@/config/localSetting";
import { messageDuration } from "@/config/settings";
import store from "@/store";
import { isEmail, isIdCard } from "zr-util/src/utils/comm/validate";
import SelectTree from "@/views/recruit/applicant/selectTree.vue";

const config = settingHelp.getConfig();
const { remoteURL } = config;
const token1 = localStorage.getItem("token");
const token2 = store.getters["user/accessToken"];
const token = token2 ? token2 : token1;

export default {
  name: "PostInfoEdit",
  components: { SelectTree },
  data() {
    return {
      headers: { Authorization: token },
      loading: true, // 加载中
      isMb: false, // 是否是移动设备
      form: {
        name: "",
        sex: "",
        fileList: [], // 附件列表
        experienceList: [], // 教育经历表格行默认数据
        degreeList: [], //学位表格行默认数据
        education: {}, // 教育经历
        familyInfo: [], // 家庭成员情况
        parcticeLiveList: [], //实习经历
        workLiveList: [], //工作经历
        projectLiveList: [], //项目经历
        languageInfoList: [], //语言情况
        topDegree: "", // 最高教育经历
        topDegreeName: "", //最高学位
      },
      basicNationality: [], //国籍数据字典
      basicLearningFormat: [], //学习形式数据字典
      basicPoliticallyState: [], //政治面貌数据字典
      basicBirthdayLocal: [], //籍贯数据字典
      basicDegree: [], //学位数据字典
      basicFamily: [], //家庭成员关系数据字典
      basicEnglishLevel: [], //英语水平
      basicLanguage: [], //语言语种
      basicSex: [
        { name: "男", code: "male" },
        { name: "女", code: "female" },
      ],
      pictureUploadAction: "", // 照片上传地址
      uploadAction: "", // 附件上传地址,附件上传前需要先投递简历
      nationArray: [],
      schoolArray: [],
      imageUrl: "",
      isView: false, // 管理员查看模式
      isRequired: true, //学生编辑模式
      isMarriedRequired: false,
      loginUser: {}, // 登录人员信息
      isTechnique: false, // 技能类
      isProfessionTech: false, // 专技类
      isPost: false, // 是否是投递页面
      unSuit: false, // 是否不合适
      collected: false, // 是否已经收藏
      positionId: "", // 投递的职位id
      postSendId: "", // 简历与投递职位的关联表id
      selectedRow: null, // 选择的行
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        birthday: [
          { required: true, message: "请输入出生年月", trigger: "blur" },
        ],
        cardNumber: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        // cardNumber: [
        //   {
        //     required: true,
        //     message: "请输入正确的身份证号",
        //     validator: validateIdCard,
        //     trigger: "blur",
        //   },
        // ],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
      curFamily: {},
      familyTableData: [],
      familyLoading: false,
      familyColumns: [
        { name: "与本人关系", code: "relationship", needDrawCell: true },
        { name: "姓名", code: "name", needDrawCell: true },
        { name: "性别", code: "sex", needDrawCell: true },
        {
          name: "出生日期",
          code: "birthDay",
          needDrawCell: true,
          width: "120",
        },
        { name: "民族", code: "nation", needDrawCell: true, width: "100" },
        {
          name: "政治面貌",
          code: "politicallyState",
          needDrawCell: true,
          width: "100",
        },
        { name: "单位和职务", code: "deptAndHeadship", needDrawCell: true },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      parcticeLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      workLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        { name: "地点", code: "location", needDrawCell: true },
        { name: "任职部门", code: "workDeptName", needDrawCell: true },
        { name: "任职职位", code: "workPostName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      projectLiveColumns: [
        { name: "开始时间", code: "startLiveTime", needDrawCell: true },
        { name: "结束时间", code: "endLiveTime", needDrawCell: true },
        { name: "项目名称", code: "projectName", needDrawCell: true },
        { name: "角色", code: "projectRole", needDrawCell: true },
        { name: "单位名称", code: "companyName", needDrawCell: true },
        {
          name: "主要职责与业绩",
          code: "achievement",
          needDrawCell: true,
          width: "120",
        },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      languageInfoColumns: [
        { name: "语言语种", code: "languageClass", needDrawCell: true },
        { name: "证书(可手动输入)", code: "languageCertificate", needDrawCell: true },
        { name: "证书成绩", code: "languageScore", needDrawCell: true },
        { name: "操作", code: "operate", needDrawCell: true },
      ],
      columns: [
        {
          code: "phase",
          name: "阶段",
          width: "100",
        },
        {
          code: "startDate",
          name: "开始时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "endDate",
          name: "结束时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "university",
          name: "学校",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "institutions",
          name: "学院/系",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "studyField",
          name: "专业",
          needDrawCell: true,
          width: "160",
        },
        {
          code: "rankNum",
          name: "综合排名",
          width: "80",
          needDrawCell: true,
        },
      ],
      searchAreaValue: "",
      selectVal: "",
      selectName: "",
      treeData: [
        {
          id: 1,
          label: "学科名称",
          children: [
            {
              id: 11,
              label: "哲学",
            },
            {
              id: 12,
              label: "理论经济学",
            },
            {
              id: 13,
              label: "应用经济学",
            },
            {
              id: 14,
              label: "法学",
            },
            {
              id: 15,
              label: "政治学",
            },
            {
              id: 16,
              label: "社会学",
            },
            {
              id: 17,
              label: "民族学",
            },
            {
              id: 18,
              label: "马克思主义理论",
            },
            {
              id: 19,
              label: "公安学",
            },
            {
              id: 110,
              label: "教育学",
            },
            {
              id: 111,
              label: "心理学",
            },
            {
              id: 112,
              label: "体育学",
            },
            {
              id: 113,
              label: "中国语言文学",
            },
            {
              id: 114,
              label: "外国语言文学",
            },
            {
              id: 115,
              label: "新闻传播学",
            },
            {
              id: 116,
              label: "历史学",
            },
            {
              id: 117,
              label: "数学",
            },
            {
              id: 118,
              label: "物理学",
            },
            {
              id: 119,
              label: "化学",
            },
            {
              id: 120,
              label: "天文学",
            },
            {
              id: 121,
              label: "地理学",
            },
            {
              id: 122,
              label: "大气科学",
            },
            {
              id: 123,
              label: "海洋科学",
            },
            {
              id: 124,
              label: "地球物理学",
            },
            {
              id: 125,
              label: "地质学",
            },
            {
              id: 126,
              label: "生物学",
            },
            {
              id: 127,
              label: "系统科学",
            },
            {
              id: 128,
              label: "科学技术史",
            },
            {
              id: 129,
              label: "力学",
            },
            {
              id: 130,
              label: "机械工程",
            },
            {
              id: 131,
              label: "光学工程",
            },
            {
              id: 132,
              label: "仪器科学与技术",
            },
            {
              id: 133,
              label: "材料科学与工程",
            },
            {
              id: 134,
              label: "冶金工程",
            },
            {
              id: 135,
              label: "动力工程及工程热物理",
            },
            {
              id: 136,
              label: "电气工程",
            },
            {
              id: 137,
              label: "电子科学与技术",
            },
            {
              id: 138,
              label: "信息与通信工程",
            },
            {
              id: 139,
              label: "控制科学与工程",
            },
            {
              id: 140,
              label: "计算机科学与技术",
            },
            {
              id: 141,
              label: "建筑学",
            },
            {
              id: 142,
              label: "土木工程",
            },
            {
              id: 143,
              label: "水利工程",
            },
            {
              id: 144,
              label: "测绘科学与技术",
            },
            {
              id: 145,
              label: "化学工程与技术",
            },
            {
              id: 146,
              label: "地质资源与地质工程",
            },
            {
              id: 147,
              label: "矿业工程",
            },
            {
              id: 148,
              label: "石油与天然气工程",
            },
            {
              id: 149,
              label: "纺织科学与工程",
            },
            {
              id: 150,
              label: "轻工技术与工程",
            },
            {
              id: 151,
              label: "交通运输工程",
            },
            {
              id: 152,
              label: "船舶与海洋工程",
            },
            {
              id: 153,
              label: "航空宇航科学与技术",
            },
            {
              id: 154,
              label: "兵器科学与技术",
            },
            {
              id: 155,
              label: "核科学与技术",
            },
            {
              id: 156,
              label: "农业工程",
            },
            {
              id: 157,
              label: "林业工程",
            },
            {
              id: 158,
              label: "环境科学与工程",
            },
            {
              id: 159,
              label: "生物医学工程",
            },
            {
              id: 160,
              label: "食品科学与工程",
            },
            {
              id: 161,
              label: "城乡规划学",
            },
            {
              id: 162,
              label: "风景园林学",
            },
            {
              id: 163,
              label: "软件工程",
            },
            {
              id: 164,
              label: "生物工程",
            },
            {
              id: 165,
              label: "安全科学与工程",
            },
            {
              id: 166,
              label: "公安技术",
            },
            {
              id: 167,
              label: "网络空间安全",
            },
            {
              id: 168,
              label: "作物学",
            },
            {
              id: 169,
              label: "园艺学",
            },
            {
              id: 170,
              label: "农业资源与环境",
            },
            {
              id: 171,
              label: "植物保护",
            },
            {
              id: 172,
              label: "畜牧学",
            },
            {
              id: 173,
              label: "兽医学",
            },
            {
              id: 174,
              label: "林学",
            },
            {
              id: 175,
              label: "水产",
            },
            {
              id: 176,
              label: "草学",
            },
            {
              id: 177,
              label: "基础医学",
            },
            {
              id: 178,
              label: "临床医学",
            },
            {
              id: 179,
              label: "口腔医学",
            },
            {
              id: 180,
              label: "公共卫生与预防医学",
            },
            {
              id: 181,
              label: "中医学",
            },
            {
              id: 182,
              label: "中西医结合",
            },
            {
              id: 183,
              label: "药学",
            },
            {
              id: 184,
              label: "中药学",
            },
            {
              id: 185,
              label: "特种医学",
            },
            {
              id: 186,
              label: "医学技术",
            },
            {
              id: 187,
              label: "护理学",
            },
            {
              id: 188,
              label: "军事思想及军事历史",
            },
            {
              id: 189,
              label: "战略学",
            },
            {
              id: 190,
              label: "战役学",
            },
            {
              id: 191,
              label: "战术学",
            },
            {
              id: 192,
              label: "军队指挥学",
            },
            {
              id: 193,
              label: "军事管理学",
            },
            {
              id: 194,
              label: "军队政治工作学",
            },
            {
              id: 195,
              label: "军制学",
            },
            {
              id: 196,
              label: "军事后勤学",
            },
            {
              id: 197,
              label: "军事装备学",
            },
            {
              id: 198,
              label: "军事训练学",
            },
            {
              id: 199,
              label: "军事后勤学与军事装备学",
            },
            {
              id: 1100,
              label: "管理科学与工程",
            },
            {
              id: 1101,
              label: "工商管理",
            },
            {
              id: 1102,
              label: "农林经济管理",
            },
            {
              id: 1103,
              label: "公共管理",
            },
            {
              id: 1104,
              label: "图书情报与档案管理",
            },
            {
              id: 1105,
              label: "艺术学",
            },
          ],
        },
      ],
      treeData1: [
        {
          id: 2,
          label: "职业教育目录",
          children: [
            {
              id: 21,
              label: "中等职业教育专业",
              children: [
                {
                  id: 211,
                  label: "6101农业类",
                },
                {
                  id: 212,
                  label: "6102林业类",
                },
                {
                  id: 213,
                  label: "6103畜牧业类",
                },
                {
                  id: 214,
                  label: "6104渔业类",
                },
                {
                  id: 215,
                  label: "6201资源勘查类",
                },
                {
                  id: 216,
                  label: "6202地质类",
                },
                {
                  id: 217,
                  label: "6203测绘地理信息类",
                },
                {
                  id: 218,
                  label: "6204石油与天然气类",
                },
                {
                  id: 219,
                  label: "6205煤炭类",
                },
                {
                  id: 2110,
                  label: "6206金属与非金属矿类",
                },
                {
                  id: 2111,
                  label: "6207气象类",
                },
                {
                  id: 2112,
                  label: "6208环境保护类",
                },
                {
                  id: 2113,
                  label: "6209安全类",
                },
                {
                  id: 2114,
                  label: "6301电力技术类",
                },
                {
                  id: 2115,
                  label: "6302热能与发电工程类",
                },
                {
                  id: 2116,
                  label: "6303新能源发电工程类",
                },
                {
                  id: 2117,
                  label: "6304黑色金属材料类",
                },
                {
                  id: 2118,
                  label: "6305有色金属材料类",
                },
                {
                  id: 2119,
                  label: "6307建筑材料类",
                },
                {
                  id: 2120,
                  label: "6401建筑设计类",
                },
                {
                  id: 2121,
                  label: "6402城乡规划与管理类",
                },
                {
                  id: 2122,
                  label: "6403土建施工类",
                },
                {
                  id: 2123,
                  label: "6404建筑设备类",
                },
                {
                  id: 2124,
                  label: "6405建设工程管理类",
                },
                {
                  id: 2125,
                  label: "6406市政工程类",
                },
                {
                  id: 2126,
                  label: "6407房地产类",
                },
                {
                  id: 2127,
                  label: "6501水文水资源类",
                },
                {
                  id: 2128,
                  label: "6502水利工程与管理类",
                },
                {
                  id: 2129,
                  label: "6503水利水电设备类",
                },
                {
                  id: 2130,
                  label: "6504水土保持与水环境类",
                },
                {
                  id: 2131,
                  label: "6601机械设计制造类",
                },
                {
                  id: 2132,
                  label: "6602机电设备类",
                },
                {
                  id: 2133,
                  label: "6603自动化类",
                },
                {
                  id: 2134,
                  label: "6605船舶与海洋工程装备类",
                },
                {
                  id: 2135,
                  label: "6606航空装备类",
                },
                {
                  id: 2136,
                  label: "6607汽车制造类",
                },
                {
                  id: 2137,
                  label: "6701生物技术类",
                },
                {
                  id: 2138,
                  label: "6702化工技术类",
                },
                {
                  id: 2139,
                  label: "6801轻化工类",
                },
                {
                  id: 2140,
                  label: "6802包装类",
                },
                {
                  id: 2141,
                  label: "6803印刷类",
                },
                {
                  id: 2142,
                  label: "6804纺织服装类",
                },
                {
                  id: 2143,
                  label: "6901食品类",
                },
                {
                  id: 2144,
                  label: "6902药品与医疗器械类",
                },
                {
                  id: 2145,
                  label: "6903粮食类",
                },
                {
                  id: 2146,
                  label: "7001铁道运输类",
                },
                {
                  id: 2147,
                  label: "7002道路运输类",
                },
                {
                  id: 2148,
                  label: "7003水上运输类",
                },
                {
                  id: 2149,
                  label: "7004航空运输类",
                },
                {
                  id: 2150,
                  label: "7006城市轨道交通类",
                },
                {
                  id: 2151,
                  label: "7007邮政类",
                },
                {
                  id: 2152,
                  label: "7101电子信息类",
                },
                {
                  id: 2153,
                  label: "7102计算机类",
                },
                {
                  id: 2154,
                  label: "7103通信类",
                },
                {
                  id: 2155,
                  label: "7104集成电路类",
                },
                {
                  id: 2156,
                  label: "7202护理类",
                },
                {
                  id: 2157,
                  label: "7203药学类",
                },
                {
                  id: 2158,
                  label: "7204中医药类",
                },
                {
                  id: 2159,
                  label: "7205医学技术类",
                },
                {
                  id: 2160,
                  label: "7206康复治疗类",
                },
                {
                  id: 2161,
                  label: "7207公共卫生与卫生管理类",
                },
                {
                  id: 2162,
                  label: "7208健康管理与促进类",
                },
                {
                  id: 2163,
                  label: "7209眼视光类",
                },
                {
                  id: 2164,
                  label: "7301财政税务类",
                },
                {
                  id: 2165,
                  label: "7302金融类",
                },
                {
                  id: 2166,
                  label: "7303财务会计类",
                },
                {
                  id: 2167,
                  label: "7304统计类",
                },
                {
                  id: 2168,
                  label: "7305经济贸易类",
                },
                {
                  id: 2169,
                  label: "7306工商管理类",
                },
                {
                  id: 2170,
                  label: "7307电子商务类",
                },
                {
                  id: 2171,
                  label: "7308物流类",
                },
                {
                  id: 2172,
                  label: "7401旅游类",
                },
                {
                  id: 2173,
                  label: "7402餐饮类",
                },
                {
                  id: 2174,
                  label: "7501艺术设计类",
                },
                {
                  id: 2175,
                  label: "7502表演艺术类",
                },
                {
                  id: 2176,
                  label: "7503民族文化艺术类",
                },
                {
                  id: 2177,
                  label: "7504文化服务类",
                },
                {
                  id: 2178,
                  label: "7601新闻出版类",
                },
                {
                  id: 2179,
                  label: "7602广播影视类",
                },
                {
                  id: 2180,
                  label: "7701教育类",
                },
                {
                  id: 2181,
                  label: "7702语言类",
                },
                {
                  id: 2182,
                  label: "7703体育类",
                },
                {
                  id: 2183,
                  label: "7804法律实务类",
                },
                {
                  id: 2184,
                  label: "7807安全防范类",
                },
                {
                  id: 2185,
                  label: "7901公共事业类",
                },
                {
                  id: 2186,
                  label: "7902公共管理类",
                },
                {
                  id: 2187,
                  label: "7903公共服务类",
                },
                {
                  id: 2188,
                  label: "7904文秘类",
                },
              ],
            },
            {
              id: 22,
              label: "高等职业教育专科专业",
              children: [
                {
                  id: 221,
                  label: "4101农业类",
                },
                {
                  id: 222,
                  label: "4102林业类",
                },
                {
                  id: 223,
                  label: "4103畜牧业类",
                },
                {
                  id: 224,
                  label: "4104渔业类",
                },
                {
                  id: 225,
                  label: "4201资源勘查类",
                },
                {
                  id: 226,
                  label: "4202地质类",
                },
                {
                  id: 227,
                  label: "4203测绘地理信息类",
                },
                {
                  id: 228,
                  label: "4204石油与天然气类",
                },
                {
                  id: 229,
                  label: "4205煤炭类",
                },
                {
                  id: 2210,
                  label: "4206金属与非金属矿类",
                },
                {
                  id: 2211,
                  label: "4207气象类",
                },
                {
                  id: 2212,
                  label: "4208环境保护类",
                },
                {
                  id: 2213,
                  label: "4209安全类",
                },
                {
                  id: 2214,
                  label: "4301电力技术类",
                },
                {
                  id: 2215,
                  label: "4302热能与发电工程类",
                },
                {
                  id: 2216,
                  label: "4303新能源发电工程类",
                },
                {
                  id: 2217,
                  label: "4304黑色金属材料类",
                },
                {
                  id: 2218,
                  label: "4305有色金属材料类",
                },
                {
                  id: 2219,
                  label: "4306非金属材料类",
                },
                {
                  id: 2220,
                  label: "4307建筑材料类",
                },
                {
                  id: 2221,
                  label: "4401建筑设计类",
                },
                {
                  id: 2222,
                  label: "4402城乡规划与管理类",
                },
                {
                  id: 2223,
                  label: "4403土建施工类",
                },
                {
                  id: 2224,
                  label: "4404建筑设备类",
                },
                {
                  id: 2225,
                  label: "4405建设工程管理类",
                },
                {
                  id: 2226,
                  label: "4406市政工程类",
                },
                {
                  id: 2227,
                  label: "4407房地产类",
                },
                {
                  id: 2228,
                  label: "4501水文水资源类",
                },
                {
                  id: 2229,
                  label: "4502水利工程与管理类",
                },
                {
                  id: 2230,
                  label: "4503水利水电设备类",
                },
                {
                  id: 2231,
                  label: "4504水土保持与水环境类",
                },
                {
                  id: 2232,
                  label: "4601机械设计制造类",
                },
                {
                  id: 2233,
                  label: "4602机电设备类",
                },
                {
                  id: 2234,
                  label: "4603自动化类",
                },
                {
                  id: 2235,
                  label: "4604轨道装备类",
                },
                {
                  id: 2236,
                  label: "4605船舶与海洋工程装备类",
                },
                {
                  id: 2237,
                  label: "4606航空装备类",
                },
                {
                  id: 2238,
                  label: "4607汽车制造类",
                },
                {
                  id: 2239,
                  label: "4701生物技术类",
                },
                {
                  id: 2240,
                  label: "4702化工技术类",
                },
                {
                  id: 2241,
                  label: "4801轻化工类",
                },
                {
                  id: 2242,
                  label: "4802包装类",
                },
                {
                  id: 2243,
                  label: "4803印刷类",
                },
                {
                  id: 2244,
                  label: "4804纺织服装类",
                },
                {
                  id: 2245,
                  label: "4901食品类",
                },
                {
                  id: 2246,
                  label: "4902药品与医疗器械类",
                },
                {
                  id: 2247,
                  label: "4903粮食类",
                },
                {
                  id: 2248,
                  label: "5001铁道运输类",
                },
                {
                  id: 2249,
                  label: "5002道路运输类",
                },
                {
                  id: 2250,
                  label: "5003水上运输类",
                },
                {
                  id: 2251,
                  label: "5004航空运输类",
                },
                {
                  id: 2252,
                  label: "5005管道运输类",
                },
                {
                  id: 2253,
                  label: "5006城市轨道交通类",
                },
                {
                  id: 2254,
                  label: "5007邮政类",
                },
                {
                  id: 2255,
                  label: "5101电子信息类",
                },
                {
                  id: 2256,
                  label: "5102计算机类",
                },
                {
                  id: 2257,
                  label: "5103通信类",
                },
                {
                  id: 2258,
                  label: "5104集成电路类",
                },
                {
                  id: 2259,
                  label: "5201临床医学类",
                },
                {
                  id: 2260,
                  label: "5202护理类",
                },
                {
                  id: 2261,
                  label: "5203药学类",
                },
                {
                  id: 2262,
                  label: "5204中医药类",
                },
                {
                  id: 2263,
                  label: "5205医学技术类",
                },
                {
                  id: 2264,
                  label: "5206康复治疗类",
                },
                {
                  id: 2265,
                  label: "5207公共卫生与卫生管理类",
                },
                {
                  id: 2266,
                  label: "5208健康管理与促进类",
                },
                {
                  id: 2267,
                  label: "5209眼视光类",
                },
                {
                  id: 2268,
                  label: "5301财政税务类",
                },
                {
                  id: 2269,
                  label: "5302金融类",
                },
                {
                  id: 2270,
                  label: "5303财务会计类",
                },
                {
                  id: 2271,
                  label: "5304统计类",
                },
                {
                  id: 2272,
                  label: "5305经济贸易类",
                },
                {
                  id: 2273,
                  label: "5306工商管理类",
                },
                {
                  id: 2274,
                  label: "5307电子商务类",
                },
                {
                  id: 2275,
                  label: "5308物流类",
                },
                {
                  id: 2276,
                  label: "5401旅游类",
                },
                {
                  id: 2277,
                  label: "5402餐饮类",
                },
                {
                  id: 2278,
                  label: "5501艺术设计类",
                },
                {
                  id: 2279,
                  label: "5502表演艺术类",
                },
                {
                  id: 2280,
                  label: "5503民族文化艺术类",
                },
                {
                  id: 2281,
                  label: "5504文化服务类",
                },
                {
                  id: 2282,
                  label: "5601新闻出版类",
                },
                {
                  id: 2283,
                  label: "5602广播影视类",
                },
                {
                  id: 2284,
                  label: "5701教育类",
                },
                {
                  id: 2285,
                  label: "5702语言类",
                },
                {
                  id: 2286,
                  label: "5703体育类",
                },
                {
                  id: 2287,
                  label: "5801公安管理类",
                },
                {
                  id: 2288,
                  label: "5802公安技术类",
                },
                {
                  id: 2289,
                  label: "5803侦查类",
                },
                {
                  id: 2290,
                  label: "5804法律实务类",
                },
                {
                  id: 2291,
                  label: "5805法律执行类",
                },
                {
                  id: 2292,
                  label: "5806司法技术类",
                },
                {
                  id: 2293,
                  label: "5807安全防范类",
                },
                {
                  id: 2294,
                  label: "5901公共事业类",
                },
                {
                  id: 2295,
                  label: "5902公共管理类",
                },
                {
                  id: 2296,
                  label: "5903公共服务类",
                },
                {
                  id: 2297,
                  label: "5802公安技术类",
                },
                {
                  id: 2298,
                  label: "5904文秘类",
                },
              ],
            },
            {
              id: 23,
              label: "高等职业教育本科专业",
              children: [
                {
                  id: 231,
                  label: "2101农业类",
                },
                {
                  id: 232,
                  label: "2102林业类",
                },
                {
                  id: 233,
                  label: "2103畜牧业类",
                },
                {
                  id: 234,
                  label: "2104渔业类",
                },
                {
                  id: 235,
                  label: "2201资源勘查类",
                },
                {
                  id: 236,
                  label: "2202地质类",
                },
                {
                  id: 237,
                  label: "2202地质类",
                },
                {
                  id: 238,
                  label: "2203测绘地理信息类",
                },
                {
                  id: 239,
                  label: "2205煤炭类",
                },
                {
                  id: 2310,
                  label: "2207气象类",
                },
                {
                  id: 2311,
                  label: "2208环境保护类",
                },
                {
                  id: 2312,
                  label: "2209安全类",
                },
                {
                  id: 2313,
                  label: "2301电力技术类",
                },
                {
                  id: 2314,
                  label: "2302热能与发电工程类",
                },
                {
                  id: 2315,
                  label: "2303新能源发电工程类",
                },
                {
                  id: 2316,
                  label: "2304黑色金属材料类",
                },
                {
                  id: 2317,
                  label: "2305有色金属材料类",
                },
                {
                  id: 2318,
                  label: "2306非金属材料类",
                },
                {
                  id: 2319,
                  label: "2307建筑材料类",
                },
                {
                  id: 2320,
                  label: "2401建筑设计类",
                },
                {
                  id: 2321,
                  label: "2402城乡规划与管理类",
                },
                {
                  id: 2322,
                  label: "2403土建施工类",
                },
                {
                  id: 2323,
                  label: "2404建筑设备类",
                },
                {
                  id: 2324,
                  label: "2405建设工程管理类",
                },
                {
                  id: 2325,
                  label: "2406市政工程类",
                },
                {
                  id: 2326,
                  label: "2407房地产类",
                },
                {
                  id: 2327,
                  label: "2501水文水资源类",
                },
                {
                  id: 2328,
                  label: "2502水利工程与管理类",
                },
                {
                  id: 2329,
                  label: "2503水利水电设备类",
                },
                {
                  id: 2330,
                  label: "2504水土保持与水环境类",
                },
                {
                  id: 2331,
                  label: "2601机械设计制造类",
                },
                {
                  id: 2332,
                  label: "2602机电设备类",
                },
                {
                  id: 2333,
                  label: "2603自动化类",
                },
                {
                  id: 2334,
                  label: "2604轨道装备类",
                },
                {
                  id: 2335,
                  label: "2605船舶与海洋工程装备类",
                },
                {
                  id: 2336,
                  label: "2606航空装备类",
                },
                {
                  id: 2337,
                  label: "2607汽车制造类",
                },
                {
                  id: 2338,
                  label: "2701生物技术类",
                },
                {
                  id: 2339,
                  label: "2702化工技术类",
                },
                {
                  id: 2340,
                  label: "2801轻化工类",
                },
                {
                  id: 2341,
                  label: "2802包装类",
                },
                {
                  id: 2342,
                  label: "2803印刷类",
                },
                {
                  id: 2343,
                  label: "2804纺织服装类",
                },
                {
                  id: 2344,
                  label: "2901食品类",
                },
                {
                  id: 2345,
                  label: "2902药品与医疗器械类",
                },
                {
                  id: 2346,
                  label: "2903粮食类",
                },
                {
                  id: 2347,
                  label: "3001铁道运输类",
                },
                {
                  id: 2348,
                  label: "3002道路运输类",
                },
                {
                  id: 2349,
                  label: "3003水上运输类",
                },
                {
                  id: 2350,
                  label: "3004航空运输类",
                },
                {
                  id: 2351,
                  label: "3006城市轨道交通类",
                },
                {
                  id: 2352,
                  label: "3007邮政类",
                },
                {
                  id: 2353,
                  label: "3101电子信息类",
                },
                {
                  id: 2354,
                  label: "3102计算机类",
                },
                {
                  id: 2355,
                  label: "3103通信类",
                },
                {
                  id: 2356,
                  label: "3104集成电路类",
                },
                {
                  id: 2357,
                  label: "3202护理类",
                },
                {
                  id: 2358,
                  label: "3203药学类",
                },
                {
                  id: 2359,
                  label: "3204中医药类",
                },
                {
                  id: 2360,
                  label: "3205医学技术类",
                },
                {
                  id: 2361,
                  label: "3206康复治疗类",
                },
                {
                  id: 2362,
                  label: "3207公共卫生与卫生管理类",
                },
                {
                  id: 2363,
                  label: "3208健康管理与促进类",
                },
                {
                  id: 2364,
                  label: "3209眼视光类",
                },
                {
                  id: 2365,
                  label: "3301财政税务类",
                },
                {
                  id: 2366,
                  label: "3302金融类",
                },
                {
                  id: 2367,
                  label: "3303财务会计类",
                },
                {
                  id: 2368,
                  label: "3305经济贸易类",
                },
                {
                  id: 2369,
                  label: "3306工商管理类",
                },
                {
                  id: 2370,
                  label: "3307电子商务类",
                },
                {
                  id: 2371,
                  label: "3308物流类",
                },
                {
                  id: 2372,
                  label: "3401旅游类",
                },
                {
                  id: 2373,
                  label: "3402餐饮类",
                },
                {
                  id: 2374,
                  label: "3501艺术设计类",
                },
                {
                  id: 2375,
                  label: "3502表演艺术类",
                },
                {
                  id: 2376,
                  label: "3504文化服务类",
                },
                {
                  id: 2377,
                  label: "3601新闻出版类",
                },
                {
                  id: 2378,
                  label: "3602广播影视类",
                },
                {
                  id: 2379,
                  label: "3701教育类",
                },
                {
                  id: 2380,
                  label: "3702语言类",
                },
                {
                  id: 2381,
                  label: "3703体育类",
                },
                {
                  id: 2382,
                  label: "3802公安技术类",
                },
                {
                  id: 2383,
                  label: "3803侦查类",
                },
                {
                  id: 2384,
                  label: "3804法律实务类",
                },
                {
                  id: 2385,
                  label: "3805法律执行类",
                },
                {
                  id: 2386,
                  label: "3806司法技术类",
                },
                {
                  id: 2387,
                  label: "3807安全防范类",
                },
                {
                  id: 2388,
                  label: "3901公共事业类",
                },
                {
                  id: 2389,
                  label: "3902公共管理类",
                },
                {
                  id: 2390,
                  label: "3903公共服务类",
                },
                {
                  id: 2391,
                  label: "3904文秘类",
                },
              ],
            },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  computed: {
    ...mapGetters({
      userPhone: "user/userPhone",
      userName: "user/userName",
      userCode: "user/userCode",
    }),
  },
  async created() {
    // 判断是否是移动设备
    this.isMb = await isMobile();
    // 路由参数 判断页面状态
    if (this.$route.query.isView) {
      this.isView = true;
      this.isRequired = false;
    }
    // 数据字典 1005修改
    await this.getNationalityArray();
    await this.getLearningFormatArray();
    await this.getPoliticallyArray();
    await this.getBirthLocalArray();
    await this.getDegreeArray();
    await this.getEnglishLevelArray();
    await this.getLanguageArray();
    //查询家庭成员关系
    await this.getFamilyArray();
    // 民族数据字典
    await this.getNationArray();
    // 民族数据字典
    await this.getSchoolArray();
    // 查询简历信息
    await this.getResumeInfo();
    // 学历列表判断
    if (this.isProfessionTech && !this.form.experienceList) {
      // 专技类
      // this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
      this.form.experienceList = [
        { phase: "大学本科毕业", resumeId: this.form.id, studyField: "" },
      ];
    }
    if (this.isProfessionTech && !this.form.degreeList) {
      // 专技类
      // this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
      this.form.degreeList.push({ degreeName: "学士", resumeId: this.form.id });
    }
    if (
      this.isTechnique &&
      (!this.form.degreeList || !this.form.degreeList.length)
    ) {
      this.form.degreeList = [{ degreeName: "无", resumeId: this.form.id }];
    }
    if (
      this.isTechnique &&
      (!this.form.experienceList || !this.form.experienceList.length)
    ) {
      // 技能类
      // this.form.experienceList = [{ phase: "大专", resumeId: this.form.id }];
      this.form.experienceList = [
        { phase: "大学专科毕业", resumeId: this.form.id },
      ];
      this.columns = [
        {
          code: "phase",
          name: "阶段",
          width: "60",
        },
        {
          code: "startDate",
          name: "开始时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "endDate",
          name: "结束时间",
          needDrawCell: true,
          width: "120",
        },
        {
          code: "university",
          name: "学校",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "institutions",
          name: "学院/系",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "studyField",
          name: "专业",
          needDrawCell: true,
          width: "155",
        },
        {
          code: "remark",
          name: "备注",
          needDrawCell: true,
          width: "150",
        },
      ];
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    onMarriedChange(e) {
      if (e === 1) {
        this.isMarriedRequired = true;
      } else {
        this.isMarriedRequired = false;
      }
    },
    loadTreeData(row) {
      if (row.phase === "大学专科毕业" || row.phase === "其它") {
        return this.treeData1;
      } else {
        return this.treeData;
      }
    },
    //国籍 1005
    async getNationalityArray() {
      let res = await getBasicData({ typeCode: "nationality" });
      if (res.success) {
        this.basicNationality = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //学习形式 1005
    async getLearningFormatArray() {
      let res = await getBasicData({ typeCode: "learningFormat" });
      if (res.success) {
        this.basicLearningFormat = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //政治面貌 1005
    async getPoliticallyArray() {
      let res = await getBasicData({ typeCode: "politicallyState" });
      if (res.success) {
        this.basicPoliticallyState = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //籍贯 1005
    async getBirthLocalArray() {
      let res = await getBasicData({ typeCode: "birthdayLocal" });
      if (res.success) {
        this.basicBirthdayLocal = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //学位 1005
    async getDegreeArray() {
      let res = await getBasicData({ typeCode: "degreeBasic" });
      if (res.success) {
        this.basicDegree = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //家庭成员关系
    async getFamilyArray() {
      let res = await getBasicData({ typeCode: "basicFamily" });
      if (res.success) {
        this.basicFamily = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //家庭成员关系
    async getEnglishLevelArray() {
      let res = await getBasicData({ typeCode: "englishLevel" });
      if (res.success) {
        this.basicEnglishLevel = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    //家庭成员关系
    async getLanguageArray() {
      let res = await getBasicData({ typeCode: "languageClass" });
      if (res.success) {
        this.basicLanguage = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 民族
    async getNationArray() {
      let res = await getBasicData({ typeCode: "nation" });
      if (res.success) {
        this.nationArray = res.data;
      } else {
        this.$message.error(res.message);
      }
    },
    async getSchoolArray() {
      let res = await getUniversity();
      if (res.success) {
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            let object = {};
            object.name = res.data[i];
            object.code = res.data[i];
            this.schoolArray.push(object);
          }
        }
      } else {
        this.$message.error(res.message);
      }
    },
    birthdayDateChange(value) {
      this.form.birthday = value;
    },
    graduateDateChange(value) {
      this.form.education.graduateDate = value;
    },
    // 身份证识别
    readCardNumber() {
      let cardNumber = this.form.cardNumber;
      if (!cardNumber) {
        this.$message.warning("请填写 [身份证号]！");
      } else if (!isIdCard(cardNumber)) {
        this.$message.warning("请填写正确格式的 [身份证号]！");
      } else {
        // --- 身份证号识别
        // 设置出生年月日
        this.form.birthday =
          cardNumber.substring(6, 10) +
          "-" +
          cardNumber.substring(10, 12) +
          "-" +
          cardNumber.substring(12, 14);
        // 设置性别
        this.form.sex =
          parseInt(cardNumber.substr(16, 1)) % 2 == 1 ? "male" : "female"; // male,female
        // 设置出生地 省市县
        // this.form.birthdayLocal = getLocation(cardNumber);
      }
    },
    // 查询简历信息
    async getResumeInfo() {
      // 管理员查看简历---------------------------------------
      if (this.$route.query.postSendId) {
        this.isView = true;
        this.isRequired = false;
        // this.isPost = true;
        let res = await getResumeInfoById({
          postSendId: this.$route.query.postSendId,
        });
        if (res.success) {
          // 回填状态参数
          this.postSendId = res.data.postSendId;
          this.unSuit = res.data.unSuit;
          this.collected = res.data.collected;
          // 回填数据
          this.dataToForm(res.data);
          this.loading = false;
        } else {
          this.$message.error(res.message);
          setTimeout(() => {
            this.loading = false;
          }, 5000);
        }
      } else {
        // 投递简历时-------------------------------------------
        if (this.$route.query.isPost && this.$route.query.positionInfoId) {
          // this.isView = true;
          this.isPost = true;
          this.loginUser = { name: this.userName, id: this.userPhone };
          let res = await getAllResumeInfoByPositionIdAndUserPhone({
            positionInfoId: this.$route.query.positionInfoId,
            userPhone: this.userPhone,
          });
          if (res.success) {
            // 回填数据
            this.dataToForm(res.data);
            // if(res.data.married&&res.data.married===1){
            //   this.isMarriedRequired=true;
            // }
            this.loading = false;
          } else {
            this.$message.error(res.message);
            setTimeout(() => {
              this.loading = false;
            }, 5000);
          }
        } else {
          // 直接点击我的简历----------------------------------
          // this.isView = true;
          // this.isPost = true;
          this.loginUser = { name: this.userName, id: this.userPhone };
          let res = await getResumeInfoByUserPhone({
            userPhone: this.userPhone,
          });
          if (res.success) {
            // 回填数据
            this.dataToForm(res.data);
            this.loading = false;
          } else {
            this.$message.error(res.message);
            setTimeout(() => {
              this.loading = false;
            }, 5000);
          }
        }
      }
    },
    // 表单数据回填
    dataToForm(data) {
      this.pictureUploadAction =
        remoteURL + "/comm/file/uploadPicture?resumeId=" + data.formData.id; // 照片上传加上url简历id
      // 是否统招一本
      // if (data.formData.education && data.formData.education.isUnify == null)
      //   data.formData.education.isUnify = 0;
      if (data.postSendId) this.postSendId = data.postSendId;
      if (data.isProfessionTech) this.isProfessionTech = data.isProfessionTech;
      if (data.isTechnique) this.isTechnique = data.isTechnique;
      if (data.formData.employeePic)
        this.imageUrl =
          remoteURL + "/comm/file/downloadPicture?resumeId=" + data.formData.id; // 照片加载url简历id
      if (!data.formData.education) data.formData.education = {};
      this.form = { ...this.form, ...data.formData };
      if (
        data.formData.experienceList &&
        data.formData.experienceList.length &&
        data.formData.experienceList.length > 0
      ) {
        this.form.topDegree =
          data.formData.experienceList[
            data.formData.experienceList.length - 1
          ].phase;
      }
      if (
        data.formData.degreeList &&
        data.formData.degreeList.length &&
        data.formData.degreeList.length > 0
      ) {
        this.form.topDegreeName =
          data.formData.degreeList[
            data.formData.degreeList.length - 1
          ].degreeName;
      }
    },
    // 照片加载
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png";
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 png 格式!");
      }
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error("上传头像图片大小不能超过 1MB!");
      }
      return isJPG && isLt1M;
    },
    // 附件下载
    handleDownload(file) {
      const token = store.getters["user/accessToken"];
      downloadFile("/comm/file/downloadFile", { id: file.id, token: token });
    },
    beforeRemove(file, fileList) {
      // 当刚选中文件没保存时直接删除，已经保存的文件再让其确认
      if (file.id) {
        return this.$confirm(`确定要删除文件：${file.name}?`);
      }
    },
    handleRemove(file, fileList) {
      if (file.id) {
        deleteFileById({ id: file.id })
          .then(function (result) {
            if (
              result.code === 200 &&
              result.success &&
              result.data === "文件删除成功"
            ) {
              fileList.splice(
                fileList.findIndex((item) => item.fileId === file.fileId),
                1
              );
            } else {
              parent.this.$message.warning(result.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    beforeUpload(file) {
      const isDoc =
        file.type === "application/msword" ||
        file.type === "application/pdf" ||
        file.type === "application/zip" ||
        file.type === "application/vnd.ms-powerpoint" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/jpeg";
      if (!isDoc) {
        this.$message.error(
          "上传附件只能是 word,pdf,ppt,jpg,jpeg,png,gif 格式!"
        );
      }
      const isLt10M = file.size / 1024 / 1024 < 50;
      if (!isLt10M) {
        this.$message.error("上传附件大小不能超过 50MB!");
      }
      const isPost = this.uploadAction.length > 0;
      if (!isPost) {
        this.$message.error("请先投递后再上传附件!");
      }
      return isDoc && isLt10M && isPost;
    },
    handleExceed(files, fileList) {
      this.$confirm(
        `当前限制选择 5 个文件，本次选择了${files.length}个文件，共选择了${
          files.length + fileList.length
        }个文件`
      );
    },
    // 上传附件接口，抛出报错
    uploadSucceed(response) {
      if (
        response.code !== 200 ||
        !response.success ||
        response.message !== "成功"
      ) {
        this.$message.warning(response.message);
        return;
      } else {
        this.$message.success({
          showClose: true,
          message: "附件上传成功!",
          duration: messageDuration,
        });
      }
    },
    // 上传算例所需额外文件失败失败
    uploadFailed(response) {
      this.$message.warning({
        showClose: true,
        message: "上传附件接口调用失败",
      });
    },
    topDegreeNameChange(value) {
      if (value == "无") {
        this.form.degreeList = [];
      }
      if (value.includes("学士")) {
        this.form.degreeList = [{ degreeName: value, resumeId: this.form.id }];
      } else if (value.includes("硕士")) {
        this.form.degreeList = [
          { degreeName: "", resumeId: this.form.id },
          { degreeName: value, resumeId: this.form.id },
        ];
      } else if (value.includes("博士")) {
        this.form.degreeList = [
          { degreeName: "", resumeId: this.form.id },
          { degreeName: "", resumeId: this.form.id },
          { degreeName: value, resumeId: this.form.id },
        ];
      }
    },
    topDegreeChange(value) {
      if (value == "其它") {
        this.form.experienceList = [];
      }
      if (value == "大学专科毕业") {
        this.form.experienceList = [
          { phase: "大学专科毕业", resumeId: this.form.id },
        ];
      } else if (value == "大学本科毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
        ];
      } else if (value == "硕士研究生毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
          { phase: "硕士研究生毕业", resumeId: this.form.id },
        ];
      } else if (value == "博士研究生毕业") {
        this.form.experienceList = [
          { phase: "大学本科毕业", resumeId: this.form.id },
          { phase: "硕士研究生毕业", resumeId: this.form.id },
          { phase: "博士研究生毕业", resumeId: this.form.id },
        ];
      }
    },
    // 选择最高教育经历
    // topDegreeChange(value) {
    //   if (value == "本科") {
    //     this.form.experienceList = [{ phase: "本科", resumeId: this.form.id }];
    //   } else if (value == "大专") {
    //     this.form.experienceList = [{ phase: "大专", resumeId: this.form.id }];
    //   } else if (value == "硕士(学术)") {
    //     this.form.experienceList = [
    //       { phase: "本科", resumeId: this.form.id },
    //       { phase: "硕士(学术)", resumeId: this.form.id },
    //     ];
    //   } else if (value == "硕士(非学术)") {
    //     this.form.experienceList = [
    //       { phase: "本科", resumeId: this.form.id },
    //       { phase: "硕士(非学术)", resumeId: this.form.id },
    //     ];
    //   } else if (value == "博士") {
    //     this.form.experienceList = [
    //       { phase: "本科", resumeId: this.form.id },
    //       { phase: "硕士", resumeId: this.form.id },
    //       { phase: "博士", resumeId: this.form.id },
    //     ];
    //   }
    // },
    // 添加阶段
    addPhase() {
      this.form.experienceList.push({ resumeId: this.form.id });
    },
    //添加学位
    addDegree() {
      this.form.degreeList.push({ resumeId: this.form.id });
    },
    // 删除阶段
    deletePhase(row) {
      this.form.experienceList.splice(
        this.form.experienceList.findIndex((item) => item.phase === row.phase),
        1
      );
    },
    //删除学位
    deleteDegree(row) {
      this.form.degreeList.splice(
        this.form.degreeList.findIndex(
          (item) => item.deleteDegree === row.deleteDegree
        ),
        1
      );
    },
    phaseChange(row) {
      row.studyField = "";
    },
    // 不合适
    doUnSuit() {
      if (this.postSendId) {
        unSuitResume({ postSendId: this.postSendId }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已标记为不合适!",
              duration: messageDuration,
            });
            this.unSuit = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 取消不合适
    doSuit() {
      if (this.postSendId) {
        suitResume({ postSendId: this.postSendId }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已取消不合适标记!",
              duration: messageDuration,
            });
            this.unSuit = false;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 收藏
    doCollect() {
      if (this.postSendId) {
        collectResume({
          postSendId: this.postSendId,
          userCode: this.userCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已收藏!",
              duration: messageDuration,
            });
            this.collected = true;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 取消收藏
    doDisCollect() {
      if (this.postSendId) {
        unCollectResume({
          postSendId: this.postSendId,
          userCode: this.userCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "已取消收藏!",
              duration: messageDuration,
            });
            this.collected = false;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        this.$message.warning("简历查询时，简历投递关联参数查询错误!");
      }
    },
    // 保存,投递
    async doSave() {
      // 手动校验，弹出消息以提示
      if (!this.checkResumeInfo(this.form)) return;
      this.$refs.postForm.validate(async (valid) => {
        if (!valid) return;
        // 保存
        if (!this.isView && this.loginUser && !this.isPost) {
          let res = await saveResumeInfo({
            formData: JSON.stringify(this.form),
            experienceList: JSON.stringify(this.form.experienceList),
            degreeList: JSON.stringify(this.form.degreeList),
            familyInfo: JSON.stringify(this.form.familyInfo),
            practiceLive: JSON.stringify(this.form.parcticeLiveList),
            workLive: JSON.stringify(this.form.workLiveList),
            projectLive: JSON.stringify(this.form.projectLiveList),
            languageInfo: JSON.stringify(this.form.languageInfoList),
          });
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "保存成功",
              duration: messageDuration,
            });
            // 回填数据
            this.dataToForm(res.data);
          } else {
            this.$message.error(res.data);
          }
        } else {
          // 投递简历
          let res = await saveResumeInfo({
            formData: JSON.stringify(this.form),
            experienceList: JSON.stringify(this.form.experienceList),
            degreeList: JSON.stringify(this.form.degreeList),
            practiceLive: JSON.stringify(this.form.parcticeLiveList),
            familyInfo: JSON.stringify(this.form.familyInfo),
            workLive: JSON.stringify(this.form.workLiveList),
            positionInfoId: this.$route.query.positionInfoId,
            userPhone: this.userPhone,
          });
          if (res.success) {
            this.$message.success({
              showClose: true,
              message: "投递成功",
              duration: messageDuration,
            });
            // 回填数据
            this.dataToForm(res.data);
            if (this.postSendId) {
              this.uploadAction =
                remoteURL +
                "/comm/file/uploadFile?postSendId=" +
                this.postSendId; // 附件上传加上postSendId
            }
          } else {
            this.$message.error(res.data);
          }
        }
      });
    },
    checkResumeInfo(data) {
      let name = data.name;
      if (!name) {
        this.$message.warning("请填写 [姓名]！");
        return false;
      }
      let sex = data.sex;
      if (!sex) {
        this.$message.warning("请填写 [性别]！");
        return false;
      }
      let mobile = data.mobile;
      if (!mobile) {
        this.$message.warning("请填写 [手机号码]！");
        return false;
      }
      let birthday = data.birthday;
      if (!birthday) {
        this.$message.warning("请填写 [出生年月日]！");
        return false;
      }
      // let politicallyState = data.politicallyState;
      // if (!politicallyState) {
      //   this.$message.warning("请填写 [政治面貌]！");
      //   return false;
      // }
      let email = data.email;
      if (!email) {
        this.$message.warning("请填写 [邮箱]！");
        return false;
      } else if (!isEmail(email)) {
        this.$message.warning("请填写正确格式的 [邮箱]！");
        return false;
      }
      let cardNumber = data.cardNumber;
      if (!cardNumber) {
        this.$message.warning("请填写 [身份证号]！");
        return false;
      } else if (!isIdCard(cardNumber)) {
        this.$message.warning("请填写正确格式的 [身份证号]！");
        return false;
      }
      //修改1005
      let politicallyState = data.politicallyState;
      if (!politicallyState || politicallyState.trim() === "") {
        this.$message.warning("请填写 [政治面貌]！");
        return false;
      }
      let birthdayLocal = data.birthdayLocal;
      if (!birthdayLocal || birthdayLocal.trim() === "") {
        this.$message.warning("请填写 [籍贯]！");
        return false;
      }
      let placeOfOrigin = data.placeOfOrigin;
      if (!placeOfOrigin || placeOfOrigin.trim() === "") {
        this.$message.warning("请填写 [出生地]！");
        return false;
      }
      let nativePlace = data.nativePlace;
      if (!nativePlace || nativePlace.trim() === "") {
        this.$message.warning("请填写 [高考时户籍所在地]！");
        return false;
      }
      let nation = data.nation;
      if (!nation || nation.trim() === "") {
        this.$message.warning("请填写 [民族]！");
        return false;
      }
      let married = data.married;
      if (!married && married !== 0) {
        this.$message.warning("请填写 [婚否]！");
        return false;
      }
      let nationality = data.nationality;
      if (!nationality || nationality.trim() === "") {
        this.$message.warning("请填写 [国籍]！");
        return false;
      }
      if (this.isProfessionTech || this.isTechnique) {
        let course = data.education.course;
        if (!course) {
          this.$message.warning("请填写 [主要课程]！");
          return false;
        }
        let topDegree = data.topDegree;
        if (!topDegree && !this.isTechnique) {
          this.$message.warning("请选择 [最高学历]！");
          return false;
        }
        let experienceList = data.experienceList;
        if (!experienceList || experienceList.length < 1) {
          this.$message.warning("请点击 [添加阶段] 填写学习阶段 ！");
          return false;
        }
        // let isUnify = data.education.isUnify;
        // if (isUnify !== 0 && isUnify !== 1 && this.isProfessionTech) {
        //   this.$message.warning("请填写 [是否为统招一本]！");
        //   return false;
        // }
        let freshGraduate = data.education.freshGraduate;
        if (!freshGraduate && this.isProfessionTech) {
          this.$message.warning("请选择 [是否应届生]！");
          return false;
        }
        let engLevel = data.education.engLevel;
        if (!engLevel && this.isProfessionTech) {
          this.$message.warning("请选择 [英语水平]！");
          return false;
        }
        let expList = data.experienceList;
        if (expList && expList.length > 0) {
          for (let i in expList) {
            if (!expList[i].phase) {
              this.$message.warning("教育经历框中请选择 [阶段]！");
              return false;
            }
            if (!expList[i].endDate) {
              this.$message.warning("教育经历框中请填写 [结束时间]！");
              return false;
            }
            if (!expList[i].university) {
              this.$message.warning("教育经历框中请填写 [学校]！");
              return false;
            }
            if (!expList[i].studyField) {
              this.$message.warning("教育经历框中请填写 [专业]！");
              return false;
            }
            if (!expList[i].learningShape) {
              this.$message.warning("教育经历框中请填写 [学习形式]！");
              return false;
            }
            // if (!expList[i].degreeNameExp) {
            //   this.$message.warning("教育经历框中请填写 [学位]！");
            //   return false;
            // }
          }
        }
        let degreeList = data.degreeList;
        if (degreeList && degreeList.length > 0) {
          for (let i in degreeList) {
            if (!degreeList[i].degreeName) {
              this.$message.warning("学位情况框中请选择 [学位]！");
              return false;
            }
            if (!degreeList[i].startDate) {
              this.$message.warning("学位情况框中请选择 [开始时间]！");
              return false;
            }
            if (!degreeList[i].endDate) {
              this.$message.warning("学位情况框中请选择 [结束时间]！");
              return false;
            }
            if (!degreeList[i].degreeDept) {
              this.$message.warning("教育经历框中请填写 [学位授予单位]！");
              return false;
            }
            if (!degreeList[i].learningFormat) {
              this.$message.warning("教育经历框中请填写 [学习形式]！");
              return false;
            }
            if (!degreeList[i].degreeScience) {
              this.$message.warning("教育经历框中请填写 [获学位学科]！");
              return false;
            }
            if (!degreeList[i].degreeStudyField) {
              this.$message.warning("教育经历框中请填写 [获学位专业]！");
              return false;
            }
          }
        }
      }
      return true;
    },
    back() {
      this.$router.back();
    },
    // 综合排名只能输入数字的控件bug
    salaryChange(e, row) {
      row.rankNum = e.target.value;
    },
    // 综合排名只能输入数字的控件bug
    salaryNewChange(e, row) {
      row.totalNumber = e.target.value;
    },
    addFamilyMember() {
      const newRow = {
        id: this.form.familyInfo.length + 1,
        isEdit: true,
      };
      this.form.familyInfo.push(newRow);
    },
    familyClick(row) {
      this.curFamily = row;
    },
    delFamily(row) {
      const index = this.form.familyInfo.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.familyInfo.splice(index, 1);
      }
    },
    addPracticeLive() {
      const newRow = {
        id: this.form.parcticeLiveList.length + 1,
        isEdit: true,
      };
      this.form.parcticeLiveList.push(newRow);
    },
    delPracticeLive(row) {
      const index = this.form.parcticeLiveList.findIndex(
        (e) => e.id === row.id
      );
      if (index !== -1) {
        this.form.parcticeLiveList.splice(index, 1);
      }
    },
    addWorkLive() {
      const newRow = {
        id: this.form.workLiveList.length + 1,
        isEdit: true,
      };
      this.form.workLiveList.push(newRow);
    },
    delWorkLive(row) {
      const index = this.form.workLiveList.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.workLiveList.splice(index, 1);
      }
    },
    addProjectLive() {
      const newRow = {
        id: this.form.projectLiveList.length + 1,
        isEdit: true,
      };
      this.form.projectLiveList.push(newRow);
    },
    delProjectLive(row) {
      const index = this.form.projectLiveList.findIndex((e) => e.id === row.id);
      if (index !== -1) {
        this.form.projectLiveList.splice(index, 1);
      }
    },
    addLanguageInfo() {
      const newRow = {
        id: this.form.languageInfoList.length + 1,
        isEdit: true,
      };
      this.form.languageInfoList.push(newRow);
    },
    delLanguageInfo(row) {
      const index = this.form.languageInfoList.findIndex(
        (e) => e.id === row.id
      );
      if (index !== -1) {
        this.form.languageInfoList.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped lang="css">
.multipleSelect {
  width: 100%;
}
.el-button {
  margin-left: 10px;
  margin-bottom: 10px;
}
>>> .el-table {
  margin-bottom: 10px;
}
.spanTitle {
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: bold;
}
>>> .el-form-item__label {
  width: 100px;
}
>>> .avatar-uploader .el-upload {
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: right;
}
>>> .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
>>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 190px;
  line-height: 190px;
  text-align: center;
}
>>> .avatar {
  width: 150px;
  height: 190px;
  display: block;
}
input[type="file"] {
  display: none;
}
</style>

<style lang="css">
.avatar-uploader input[type="file"] {
  display: none;
}
input[type="file"] {
  display: none;
}
</style>
